import { useContext, useMemo } from 'react';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { LogicGroupNames, isLogicGroup } from '../../filterQueryFormat/logic/LogicGroup';
import { useOnChangeHandlers } from '../../hooks/useOnChangeHandlers';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const setLogicGroupNameOnCurrentAndChildrenLogicGroups = (logicGroup, newLogicGroupName) => {
  let updatedLogicGroup = logicGroup;
  if (updatedLogicGroup.has('logicGroupName')) {
    updatedLogicGroup = updatedLogicGroup.set('logicGroupName', newLogicGroupName);
  }
  if (updatedLogicGroup.conditions.size > 0) {
    updatedLogicGroup = updatedLogicGroup.update('conditions', conditions => {
      return conditions.map(c => {
        if (isLogicGroup(c)) {
          return setLogicGroupNameOnCurrentAndChildrenLogicGroups(c, newLogicGroupName);
        } else {
          return c;
        }
      });
    });
  }
  return updatedLogicGroup;
};
const FilterGroupLogicGroupToggle = ({
  logicGroupIndex
}) => {
  const {
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    handleOnChange
  } = useOnChangeHandlers();
  const options = useMemo(() => [{
    value: LogicGroupNames.OR,
    text: I18n.text(`newCustomerDataFilters.logicOperator.or`)
  }, {
    value: LogicGroupNames.AND,
    text: I18n.text(`newCustomerDataFilters.logicOperator.and`)
  }], []);
  const getLogicGroup = () => {
    var _internalDraftValue$c;
    return internalDraftValue === null || internalDraftValue === void 0 || (_internalDraftValue$c = internalDraftValue.conditions.get(String(logicGroupIndex))) === null || _internalDraftValue$c === void 0 ? void 0 : _internalDraftValue$c.logicGroupName;
  };
  const handleLogicGroupChange = e => {
    if (internalDraftValue) {
      const newInternalDraftValue = internalDraftValue.updateIn(['conditions', String(logicGroupIndex)], logicGroupInstance => setLogicGroupNameOnCurrentAndChildrenLogicGroups(logicGroupInstance, e.target.value));
      dispatch({
        type: 'internalDraftValue',
        payload: newInternalDraftValue
      });
      handleOnChange(newInternalDraftValue);
    }
  };
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "fr-filter-group-logic-group-toggle",
    value: getLogicGroup(),
    onChange: handleLogicGroupChange,
    options: options,
    buttonUse: "unstyled",
    padding: "0"
  });
};
export default FilterGroupLogicGroupToggle;